import { isBeekeeperFeatureEnabled, isFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { isInstanceSuperAdmin, isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_INTEGRATION, BEEKEEPER_LUMAPPS_SINGLE_DOMAIN, LUMAPPS_INTEGRATION_MAIN } from '../constants';

export const isBeekeeperIntegrationEnabled = isFeatureEnabled(BEEKEEPER_INTEGRATION);
const isLumappsSingleDomainDevelopmentEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_LUMAPPS_SINGLE_DOMAIN);

export const isBeekeeperSuperAdminAllowed = createSelector(
    isBeekeeperIntegrationEnabled,
    isSuperAdmin,
    (isEnabled, isSuperAdmin) => isEnabled && isSuperAdmin,
);

export const isBeekeeperAdminAllowed = createSelector(
    isBeekeeperIntegrationEnabled,
    isInstanceSuperAdmin,
    (isEnabled, isAdmin) => isEnabled && isAdmin,
);

export const isLumappsSingleDomainEnabled = createSelector(
    isBeekeeperIntegrationEnabled,
    isLumappsSingleDomainDevelopmentEnabled,
    (isIntegrationEnabled, isSingleDomainEnabled) => isIntegrationEnabled && isSingleDomainEnabled,
);

export const isLumappsIntegrationMainEnabled = isFeatureEnabled(LUMAPPS_INTEGRATION_MAIN);

/**
 * Beekeeper is the customer's main platform, meaning user, group and segment administration is
 * handled in Beekeeper rather than in LumApps.
 */
export const isBeekeeperMainPlatform = createSelector(
    isBeekeeperIntegrationEnabled,
    isLumappsIntegrationMainEnabled,
    (isIntegrationEnabled, isLumappsMain) => isIntegrationEnabled && !isLumappsMain,
);
